import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CapitalExpenditureMain from './components/capitalExpenditure/CapitalExpenditureMain';
import BudgetMain from './components/budget/BudgetMain';
import Login from './components/auth/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import TokenSearchPage from './components/token/TokenSearchPage';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem('authToken');
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Login Route */}
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/capital-expenditure/new-data" replace />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />

          {/* Protected Routes */}
          <Route
            path="/capital-expenditure/data-view"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CapitalExpenditureMain activeTab="dataView" onLogout={handleLogout} isAuthenticated={isAuthenticated} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/capital-expenditure/settings"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CapitalExpenditureMain activeTab="settings" onLogout={handleLogout} isAuthenticated={isAuthenticated} />
              </ProtectedRoute>
            }
          />

          {/* New Data Route - unprotected (token flow handled inside) */}
          <Route
            path="/capital-expenditure/new-data"
            element={
              <CapitalExpenditureMain activeTab="newData" onLogout={handleLogout} isAuthenticated={isAuthenticated} />
            }
          />

          <Route
            path="/budjet"
            element={
              <BudgetMain onLogout={handleLogout} isAuthenticated={isAuthenticated} />
            }
          />

          <Route
            path="/capital-expenditure/institution-manager"
            element={
              <CapitalExpenditureMain activeTab="institutionManager" onLogout={handleLogout} isAuthenticated={isAuthenticated} />
            }
          />

          {/* Token Search Route - Unprotected */}
          <Route
            path="/token-search"
            element={
              <TokenSearchPage />
            }
          />

          {/* Default Route -> Token Search */}
          <Route
            path="/"
            element={
              <Navigate to="/token-search" replace />
            }
          />

          {/* Catch all -> Token Search */}
          <Route
            path="*"
            element={
              <Navigate to="/token-search" replace />
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
